var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
import Model from "./Model.js";
class ComboModel extends Model {
}
__publicField(ComboModel, "$name", "ComboModel");
__publicField(ComboModel, "fields", [
  /**
   * Value for the Combo's list record.
   * @field {String|Number|*} value
   */
  { name: "value" },
  /**
   * Display text for the Combo's list record.
   * @field {String} text
   */
  { name: "text" }
]);
ComboModel._$name = "ComboModel";
export {
  ComboModel as default
};
